import { FormGroup } from '@angular/forms';

export class CompanyReallocateValidation {
  static validate (formGroup: FormGroup): any {
    const company = formGroup.controls.company.value;
    const newCompany = formGroup.controls.newCompany.value;

    if (!company || !newCompany) {
      return null;
    }

    if (company.id === newCompany.id) {
      return formGroup.controls.newCompany.setErrors({
        companyReallocateDuplicated: true
      });
    }

    return null;
  }
}
